$('document').ready(function () {

    var $videoModal = $('#video-modal.modal');
    var currVimeoId = "";
    $(document.body).on('click', 'a.is-vimeo', function (e) {
        e.preventDefault();
        var videoId = $(this).attr('data-vimeo-id');
        loadVimeo(videoId);
    });

    $videoModal.on('hidden.bs.modal', function (e) {
        $('#video-modal.modal').find("#modal-player").find("iframe[src*=vimeo]").remove();
    });

    function loadVimeo(videoId) {
        $videoModal.modal();
        playVimeo(videoId);

    }

    function playVimeo(id) {
        currVimeoId = id;
        var vimeoPlayer = $('<iframe id="' + currVimeoId + '" src="https://player.vimeo.com/video/' + currVimeoId + '?title=0&byline=0&portrait=0&muted=1&loop=1&autopause=0&autoplay=1" frameborder="0" allow="autoplay; fullscreen" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
        $('#video-modal.modal').find("#modal-player").html(vimeoPlayer);
        
    }
});